import { useEffect, useState } from "react";
import AuthorisedRepresentativeManagementComponent from "../../components/authorisedRepresentativeManagement/AuthorisedRepresentativeManagementComponent";
import { useApiClient } from "../../shared/customHooks";
import { PageHeader } from "../../components/header/PageHeader";
import { RoleId } from "../../shared/enums/Role";
import { useGlobalContext } from "../../shared/GlobalContext";

export default function DepartmentView() {
  const api = useApiClient("UserManagement", { identity: true });
  const [users, setUsers] = useState<any[]>([]);
  const {
    accountInfo: { isManager },
  } = useGlobalContext();

  useEffect(() => {
    api.fetchData(`GetUsersByRoles/6`).then((res: any) => {
      setUsers(res.data);
    });
  }, []);

  const inviteText = "Select this button to send an invitation to a KIS Department of Education (DE) user to create a KIS portal account";

  return (
    <div className="w-full">
      <PageHeader
        headerText={[
          {
            value: "Department User Details",
            icon: "view-app-icon mr-3 mt-0",
          },
        ]}
        icon={"icon"}></PageHeader>
      <div className="flex flex-column align-items-start w-full height-calc">
        <AuthorisedRepresentativeManagementComponent
          inviteText={inviteText}
          id={""}
          data={users}
          apiClient={api}
          otherValues={{
            roleType: RoleId.Department,
          }}
          tooltipText="Invite Department User"
          label="Invite a user to join the KIS portal"
          advisory="Enter the email address of the KIS Department of Education (DE) user that you wish to invite"
          showInvite={isManager}
          domain="education.vic.gov.au"
          emailValidationMsg="Please enter a valid department email address"
        />
      </div>
    </div>
  );
}
